import { render } from "./ItemCommentsComponent.vue?vue&type=template&id=9332a16a&scoped=true&ts=true"
import script from "./ItemCommentsComponent.vue?vue&type=script&lang=ts"
export * from "./ItemCommentsComponent.vue?vue&type=script&lang=ts"

import "./ItemCommentsComponent.vue?vue&type=style&index=0&id=9332a16a&lang=sass&scoped=true"
/* custom blocks */
import block0 from "./ItemCommentsComponent.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9332a16a"]])

export default __exports__